import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img
            src="https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/49d2292e6304cd47d0c8a300fcc7709c.png"
            alt="빌리브 청소"
            className="h-8 w-auto"
          />
          <span className={`text-xl font-bold tracking-tight ${scrolled ? "text-gray-900" : "text-white"}`}>
            빌리브 청소
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: "서비스", id: "services" },
            { label: "가격", id: "pricing" },
            { label: "후기", id: "reviews" },
            { label: "문의하기", id: "contact" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-gray-700 hover:text-amber-500" : "text-white/90 hover:text-white"
              }`}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="bg-amber-500 text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            무료 견적 받기
          </button>
        </nav>

        <button
          className="md:hidden cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-2xl ${scrolled ? "text-gray-900" : "text-white"} ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {[
            { label: "서비스", id: "services" },
            { label: "가격", id: "pricing" },
            { label: "후기", id: "reviews" },
            { label: "문의하기", id: "contact" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-gray-700 text-sm font-medium text-left cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="bg-amber-500 text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap w-fit"
          >
            무료 견적 받기
          </button>
        </div>
      )}
    </header>
  );
}
